export class ResetPasswordModel {
    verification_token = null;
    password = null;
    confirmPassword = null;
  }
  